import {Role } from "./role";
import { Capability } from "./capability";
import { Subscription } from "./subscription";

export class User {
    private _username:string;
    private _firstName:string;
    private _lastName:string;
    private _password:string;
    private _enabled:boolean;
    private _id:number;
    private _role:Role;
    private _caps:Capability[];
    private _companyID:number;
    private _companyName:string;
    private _companyPrimaryContact:string;
    private _subscription:Subscription;

    constructor() {
        this._role = Role.Registered;
        this._caps = [];
        this._enabled = true;
    }

    public get companyPrimaryContact() : string {
		return this._companyPrimaryContact;
	}

	public set companyPrimaryContact(v:string) {
		this._companyPrimaryContact = v;
	}

    public get companyName() : string {
		return this._companyName;
	}

	public set companyName(v: string) {
		this._companyName = v;
	}

    public get enabled() : boolean {
		return this._enabled;
	}

	public set enabled(value: boolean) {
		this._enabled = value;
	}

    set companyID(v:number) {
        this._companyID = v;
    }

    get companyID() {
        return this._companyID;
    }

    get username() {
        return this._username;
    }
    set username(v:string) {
        this._username = v;
    }

    set password(v:string) {
        this._password = v;
    }

    get password() {
        return this._password;
    }

    set id(v:number) {
        this._id = v;
    }

    get id() {
        return this._id;
    }

    get capabilities() {
        return this._caps;
    }

    set capabilities(v:Capability[]) {
        this._caps = v;
    }

    set role(v:Role) {
        this._role = v;
    }
    get role() {
        return this._role;
    }

    get roleName() {
        return Role[this._role];
    }

    set firstName(v:string) {
        this._firstName = v;
    }
    get firstName() {
        return this._firstName;
    }
    set lastName(v:string) {
        this._lastName = v;
    }
    get lastName() {
        return this._lastName;
    }

    set subscription(v:Subscription) {
        this._subscription = v;
    }

    get subscription() {
        return this._subscription;
    }

    public hasCapability(cap:Capability) {
        return this._caps && this._caps.some(c => c == cap);
    }

    public getDisplayName() {
        let displayName = [];
        if (this.firstName) {
            displayName.push(this.firstName);
        }
        if (this.lastName) {
            displayName.push(" ");
            displayName.push(this.lastName);
        }
        if (!displayName.length) {
            displayName = [this._username];
        }
        return displayName.join("");
    }

    public hasActiveSubscription() {
        if (this.subscription) {
            return this.subscription.isActiveSubscription();
        }
        // for people who do not have a subscription object, we return true here.
        return true;
    }


}


// WEBPACK FOOTER //
// ./src/app/shared/models/user.ts